import LanguageKeys from './de'

export class LanguageKeysEn extends LanguageKeys {
  public daysEn = {
    Mi: 'We',
    Do: 'Th',
    Fr: 'Fr',
    Sa: 'Sa',
    So: 'Su',
    Mo: 'Mo',
  }
  public typesEn = {
    Kino: 'Cinema',
  }

  public WELCOME_HEADLINE = 'Welcome to Fusion 2026'
  public WELCOME_MESSAGE =
    'This is the mobile timetable for your smartphone. Browse through the program and create your own favorites.'
  public WELCOME_MESSAGE_INSTALL_END =
    'Once clicked, an icon will appear on your home screen, behind which the timetable is located. Then start the app once, making it usable offline.'
  public WELCOME_MESSAGE_NOT_RELEASED =
    'The program is not released yet. Come back later.'

  public INSTALL_PROMT_HEADLINE = 'Offline available'
  public INSTALL_PROMT_MESSAGE =
    'This timetable also works offline. Install it on your phone and use it like an app.'
  public INSTALL_MANUALLY_HEADLINE =
    "This timetable also works offline and here's how:"
  public INSTALL_MANUALLY_MESSAGE =
    '- Open in Chrome<br />- Open the browser menu<br />- Click <b>"Add to Home Screen"</b>'
  public INSTALL_MANUALLY_MESSAGE_IOS =
    '- Open in Safari<br />- Click the menu<br />- Select "Add to Home Screen"'
  public INSTALL_INSTRUCTIONS_BUTTON = 'Instructions as screenshot'

  public WELCOME_BUTTON_START = 'Start'
  public NEXT = 'Next'
  public BACK = 'Back'

  public INSTRUCTIONS_HEADLINE = 'Instructions'
  public INSTRUCTIONS_STEP_1 = 'Step 1'
  public INSTRUCTIONS_STEP_2 = 'Step 2'

  public NO_PHOTOS_BUTTON_OK = 'OK, understood'

  public PASSWORD_HEADLINE = 'Passwort required!'
  public PASSWORD_MESSAGE = 'Please enter the password here.'
  public PASSWORD_INPUT_PLACEHOLDER = 'Enter password here'

  public TENT_TITLE = 'Where is my Tent?'
  public TENT_MESSAGE =
    'Drag the tent icon to the location on the map where you are camping and lock it with the Lock Button.'
  public TENT_DRAG_ME = 'Drag me'
  public TENT_LOCK_ME = 'Lock me'

  public HELP_HEADLINE =
    'Whenever you need help, contact the following numbers:'

  public HELP_MEDICAL = 'Medical emergencies and fire department:'
  public HELP_MEDICAL_NUMBER = '+49 39833 / 2740112'
  public HELP_OFFICE = 'Emergency number of the festival office:'
  public HELP_OFFICE_NUMBER = '+49 39833 / 2740400'
  public HELP_AWARENESS = 'Contact point for awareness requests:'
  public HELP_AWARENESS_NUMBER = '+49 39833 / 699799'

  public SPECIAL_POSTER_HEADLINE = '25th Fusion Festival anniversary poster'
  public SPECIAL_POSTER_TEXT =
    'For a donation from Sunday. At all rubbish stations and ZOB Bassliner. The donation will go to Medico International Nothilfe Gaza.'

  public LOADING = 'load timetable...'

  public BUTTON_OK = 'OK'

  public BUTTON_TIMETABLE = 'Program'
  public BUTTON_FAVORITES = 'Favorites'
  public BUTTON_MAP = 'Map'
  public BUTTON_DEPARTURE = 'Departure'
  public BUTTON_TIMETABLE_CLASSIC = 'Timetable'
  public BUTTON_FILTER_TIMETABLE = 'Filter timetable'
  public BUTTON_FILTER_FAVORITES = 'Filter favorites'
  public BUTTON_UNDERSTOOD = 'Ok'

  public TITLE_PAGE_FILTER = 'Filter program'

  public TITLE_PAGE_DEPARTURE = 'Latest infos from ZOB'
  public PAGE_DEPARTURE_NEUSTRELITZ = 'Shuttle Neustrelitz'
  public PAGE_DEPARTURE_BASSLINER = 'Bassliner'

  public DAY = (day: string) => {
    const dayStr: string = (this.daysEn as any)[day]
    return dayStr || day
  }
  public TYPE = (type: string) => {
    const typeStr: string = (this.typesEn as any)[type]
    return typeStr || type
  }

  // public DAY = (day: string) => daysEn[day] || day
  // public TYPE = (type: string) => type

  public OCLOCK = "o'clock"

  public FILTER_WHEN = 'WHEN'
  public FILTER_WHAT = 'WHAT'
  public FILTER_FLOOR = 'WHERE'
  public FILTER_GENRE = 'Categories'
  public FILTER_CATEGORIES = 'Genre'
  public FILTER_STYLES = 'Genre'
  public FILTER_FLOORS = 'Floors'
  public FILTER_FLOORS_INDOOR = 'Floors - Indoor'
  public FILTER_FLOORS_OUTDOOR = 'Floors - Outdoor'

  public FILTER_BUTTON_CHANGE = 'CHANGE'
  public FILTER_BUTTON_DELETE = 'Delete'
  public FILTER_ALL_TYPES = 'All types'
  public FILTER_ALL_FLOORS = 'All floors'
  public FILTER_CURRENT_SELECTION = 'Search Artist'

  public TIMETABLE_NO_ENTRIES_HEADLNE = 'No shows found.'
  public TIMETABLE_NO_ENTRIES_MESSAGE =
    'Change the filters to see more shows here.'

  public FAVORITES_NO_ENTRIES_HEADLNE = 'No entries found'
  public FAVORITES_NO_ENTRIES_MESSAGE_DAY =
    'OOOooops… there are no bookmarks in your favorites for this day. Please have a look into our festival program.'
  public FAVORITES_NO_ENTRIES_MESSAGE =
    'OOOooops… there are no bookmarks in your favorites. Please have a look into our festival program.'

  public IMPORT_EXPORT_BTN = 'Import/Export'
  public INFO_CLOSE_BTN = 'Close Info'
  public SEARCH_BTN = 'Search'
  public SEARCH_RESULT = 'Search'
  public SEARCH_OK_BTN = 'OK'
  public SEARCH_CLOSE_BTN = 'Close'
  public SEARCH_PLACEHOLDER = 'Search program'
  public SEARCH_PLACEHOLDER_ARTIST = 'Search program'

  public FAVORITES_EXPORT_HEADLINE = 'Favorites Export'
  public FAVORITES_EMAIL_DESC =
    'Click the button to send an email with your favorites to your friends.'
  public FAVORITES_CLIPBOARD_DESC =
    'Or copy the code to the ckipboard and send it with an app of your choice'
  public FAVORITES_SHARE_DESC =
    'Share yout favorites with an app of your choice like Signal or Telegram.'
  public FAVORITES_EMAIL_BTN = 'Send with Email'
  public FAVORITES_CLIPBOARD_BTN = 'Copy to clipboard'
  public FAVORITES_SHARE_BTN = 'Share Code'

  public FAVORITES_SHARE_TITLE = 'Fusion Timetable'
  public FAVORITES_SHARE_TEXT = (link: string) =>
    `
I want to share my Fusion favorites with you. You can import them into the app with the following link:
${link}

Manuell Import - use this only if the automatic import is not working. 
Open the app and navigate to Menu -> Favorites -> Import/Export.
Copy the text between START and ENDE into the "Import" - field inside the app.`

  public FAVORITES_SHARE_URL_FUSION = 'https://timetable.fusion-festival.de/'
  public FAVORITES_SHARE_URL_AT_TENSION =
    'https://timetable.attension-festival.de/'

  public FAVORITES_IMPORT_HEADLINE = 'Favorites Import'
  public FAVORITES_IMPORT_DESC =
    'Insert the import code from the mail or message here and click the button:'
  public FAVORITES_IMPORT_BTN = 'import'
  public FAVORITES_CLOSE_BTN = 'Close'

  public FAVORITES_COPY_CLIPBOARD_SUCCESS =
    'The code was copied into the clipboard. Paste the code in another app and send ot to your friends.'
  public FAVORITES_IMPORT_SUCCESS = 'Favorites were imported.'
  public FAVORITES_IMPORT_ERROR = 'Import error. Please check the input.'

  public RELOAD_APP_VERSION_INFO = 'Version info'
  public RELOAD_APP_CURRENT_VERSION = 'Current version:'
  public RELOAD_APP_LAST_UPDATE = 'Last Update:'
  public RELOAD_APP_RELOAD_HEADLINE = 'Hard Reload Button'
  public RELOAD_APP_DESC =
    'To update the app you have to close the browser tab or the app and then open again.'
  public RELOAD_APP_CONFIRMATION =
    'Click ok if you have internet and reload the app.'
  public RELOAD_APP_BTN = 'Reload APP'

  // Map
  public NEARBY = 'Nearby'
  public PLACES = 'Places'
  public LOCATION_DENIED =
    'You could not be located. You may need to allow your browser access to your location and reload the app.'
  public LAYERS_MODAL_BUTTON_CLOSED = 'Show/hide legend'
  public SHOW_FLOORS = 'Show Floors'
  public HIDE_FLOORS = 'Hide Floors'
  public SHOW_WC = 'Show WC/Showers'
  public HIDE_WC = 'Hide WC/Showers'
  public SHOW_WATER = 'Show Water Stations'
  public HIDE_WATER = 'Hide Water Stations'
  public SHOW_EXITS = 'Show Exits'
  public HIDE_EXITS = 'Hide Exits'
  public SHOW_NO_BORDER = 'Activate Barrier-Free Mode'
  public HIDE_NO_BORDER = 'Deactivate Barrier-Free Mode'
  public BIKE_PROHIBITED = 'Bike prohibited'
  public BIKE_PROHIBITED_DESC = '= push your bike'
  public BIKE_ALLOWED = 'Bike allowed'
  public BIKE_ALLOWED_DESC = 'Bike friendly'
  public CLOSE = 'Close'
  public FIXED_PATH = 'Fixed Path'
  public SEMI_FIXED_PATH = 'Semi Fixed'
  public BARRIER_FREE_FLOOR = 'Barrier-Free Floor'
  public BARRIER_FREE_BAR = 'Barrier-Free Bar'
  public BARRIER_FREE_CAMP = 'Barrier-Free Camp'
  public BARRIER_FREE_WC = 'Barrier-Free Toilet'
  public BARRIER_FREE_SHOWER = 'Barrier-Free Shower'
  public SEMI_FIXED_PATH_DESC = 'Unsafe when raining'
  public BARRIER_FREE_FLOOR_DESC =
    'With at least one solid floor or a paved platform.'
  public BARRIER_FREE_BAR_DESC = 'With a partially lowered table'
  public NO_BORDER_TITLE = 'Barrier-free mode'
  public NO_BORDER_MESSAGE = 'You activated the barrier-free mode.'

  // Departure
  public DEPARTURE_NO_INFO_HEADLINE = 'No infos available'
  public DEPARTURE_NO_INFO_MESSAGE =
    'Currently there are no infos available. Please check again later.'
  public DEPARTURE_LAST_UPDATE = 'last update: '

  public DEPARTURE_LOAD_ERROR =
    'Sorry, there is no internet connection. Please try again later.'
  public DEPARTURE_LOADING = 'loading data ...'
  public FONT_SIZE = 'Adjust font size'
  public ARTIST_NOTES = 'Your notes'
  public ARTIST_NOTES_SAVE = 'Save'
  public ARTIST_HIGHLIGHT = 'Highlight artist'
  public ARTIST_HIGHLIGHT_REMOVE = 'Remove artist highlight'
}

export default LanguageKeysEn
